<template>
	<div class="video-presenter">
		<video v-for="(item, index) in presenterItems"
			   :class="{ active: currentItemIndex === index }"
			   :autoplay="index === 0"
			   loop muted>
			<source :src="item.presenter_video.url">
		</video>
		<div class="overlay"></div>
		<div class="flex items-center">
			<div class="selector">
				<a v-for="(item, index) in presenterItems"
				   @mouseenter="currentItemIndex = index"
				   @touchstart="currentItemIndex = index"
				   @mouseleave="previousItemIndex = index"
				   @touchend="previousItemIndex = index"
				   @click="currentItemIndex = index"
				   class="select"
				   :aria-pressed="currentItemIndex === index">
					{{ item.title }}
				</a>
				<div class="spacer"></div>
				<div class="content" v-html="content"></div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'VideoPresenter',
	props: {
		items: String,
		content: String,
	},
	data() {
		return {
			presenterItems: {},
			currentItemIndex: 0,
			previousItemIndex: -1,
		}
	},
	methods: {
		pausePreviousVideo() {
			if (this.previousItemIndex >= 0 && this.previousItemIndex < this.presenterItems.length)
				this.videos[this.previousItemIndex].pause();
		},
		playCurrentVideo() {
			if (this.currentItemIndex >= 0 && this.currentItemIndex < this.presenterItems.length)
				this.videos[this.currentItemIndex].play();
		}
	},
	watch: {
		currentItemIndex: function() {
			this.pausePreviousVideo();
			this.playCurrentVideo();
		}
	},
	computed: {
		videos: function() {
			return this.$el.querySelectorAll('video');
		}
	},
	mounted: function() {
		this.presenterItems = JSON.parse(this.items);
	}
};
</script>
